import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

const state = {
  bAuth: false,
  ContactUs: false,
  dialogVisibleLogin: false,
  searchTxt:'',
  highSearch:false,
}

const mutations = {
  loginStatue (state, loginstatus) {
    state.bAuth = loginstatus
  },
  ContactUs (state, boom) {
    state.ContactUs = boom
  },
  dialogVisibleLogin (state, start) {
    state.dialogVisibleLogin = start
  },
  setSearchTxt (state, val) {
    state.searchTxt = val
  },
  setHighSearch(state, val) {
    state.highSearch = val
  },
}
const store = new Vuex.Store({
  state: state,
  mutations: mutations
})

export default store



// WEBPACK FOOTER //
// ./src/store/store.js